import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import AuthPage from "./pages/AuthPage";
import LoginForm from "./components/LoginForm";
import ForgotPasswordForm from "./components/ForgotPasswordForm";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import Layout from "./utils/Layout";
import Users from "./pages/Users";
import UserDetail from "./pages/UserDetail";
import ReportedPosts from "./pages/ReportedPosts";
import PostDetail from "./pages/PostDetail";
import JobsPage from "./pages/JobsPage";
import JobDetail from "./pages/JobDetail";
import OverviewPage from "./pages/OverviewPage";
import UserGeolocation from "./pages/UserGeolocation";
import Applicants from "./pages/Applicants";
import PrivateRoute from "./utils/PrivateRoute";
import AddJobPage from "./pages/AddJobPage";
import ApplicantDetail from "./pages/ApplicantDetail";
import AdminManagement from "./pages/AdminManagement";
import AdminDetail from "./pages/AdminDetail";
import AddAdmin from "./pages/AddAdmin";
import Attributes from "./pages/Attributes";
import HealthFacility from "./pages/HealthFacility";
import HealthFacilityDetail from "./pages/HealthFacilityDetail";
import AddHealthFacility from "./pages/AddHealthFacility";
import ViewHealthFacility from "./pages/ViewHealthFacility";
import JobApplications from "./pages/JobApplications";
import JobCategories from "./pages/JobCategories";
import JobApplicationDetail from "./pages/JobApplicationDetail";
import Profile from "./pages/Profile";
import EventsPage from "./pages/EventsPage";
import EventDetails from "./pages/EventDetails";
import CreateEvent from "./pages/CreateEvent";
import { useSelector } from "react-redux";
import Alumni from "./pages/Alumni";
import TrainingPrograms from "./pages/TrainingPrograms";
import DeleteAccount from "./pages/DeleteAccount";
import PrivacyPolicyPage from "./pages/PrivacyPolicy";

function App() {

  const SuperAdminRoute = ({ children }) => {
    const { admin_type } = useSelector((state) => state.auth);
    
    if (admin_type !== 'super_admin') {
      // Redirect to dashboard if not a super admin
      return <Navigate to="/dashboard" replace />;
    }
    
    return children;
  };
  return (
    <Routes>
      <Route element={<AuthPage />}>
        <Route path="/" element={<LoginForm />} />
        <Route path="/forgot-password" element={<ForgotPasswordForm />} />
      </Route>
      <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
      <Route path="/delete-account" element={<DeleteAccount />} />
      <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
      <Route element={<PrivateRoute/>}>
        <Route path="/dashboard" element={<Layout />} >
          <Route index element={<OverviewPage />} />
          <Route path="users" element={<Users />} />
          <Route path="profile" element={<Profile />} />
          <Route path="users/:slug" element={<UserDetail />} />
          <Route path="reported-posts" element={<ReportedPosts />} />
          <Route path="reported-posts/:id" element={<PostDetail />} />
          <Route path="jobs" element={<JobsPage />} />
          <Route path="add-job" element={<AddJobPage />} />
          <Route path="jobs/:id" element={<JobDetail />} />
          <Route path="job-applications" element={<JobApplications />} />
          <Route path="job-applications/:id" element={<JobApplicationDetail />} />
          <Route path="job-categories" element={<JobCategories />} />
          <Route path="events" element={<EventsPage />} />
          <Route path="events/:id" element={<EventDetails />} />
          <Route path="create-event" element={<CreateEvent />} />
          <Route path="user-geolocation" element={<UserGeolocation />} />
          <Route path="applicants" element={<Applicants />} />
          <Route path="applicants/:id" element={<ApplicantDetail />} />
          {/* <Route path="admin" element={<AdminManagement />} />
          <Route path="add-admin" element={<AddAdmin />} />
          <Route path="admin/:id" element={<AdminDetail/>} /> */}
            <Route path="admin" element={
            <SuperAdminRoute>
              <AdminManagement />
            </SuperAdminRoute>
          } />
          <Route path="add-admin" element={
            <SuperAdminRoute>
              <AddAdmin />
            </SuperAdminRoute>
          } />
          <Route path="admin/:id" element={
            <SuperAdminRoute>
              <AdminDetail/>
            </SuperAdminRoute>
          } />
          <Route path="attributes" element={<Attributes/>} />
          <Route path="health-facilities" element={<HealthFacility/>} />
          <Route path="health-facilities/:id" element={<ViewHealthFacility/>} />
          <Route path="add-health-facility" element={<AddHealthFacility/>} />
          <Route path="alumni" element={<Alumni/>} />
          <Route path="training-programs" element={<TrainingPrograms/>} />

        </Route>
      </Route>
    </Routes>
  );
}

export default App;
